import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DeviceProvider } from '../../providers/device/device';

/**
 */
@Component({
	selector: 'frequency-bar-graph',
	templateUrl: 'frequency-bar-graph.html'
})
export class FrequencyBarGraphComponent {
	private _stream: MediaStream;
	@Input() public set stream(stream: MediaStream) {
		let previousStream = this._stream;
		this._stream = stream;
		if (stream && (!previousStream || previousStream.id != stream.id)) {
			this.init();
		}
	}

	@Input() public bgColor: string = "#000000";
	@Input() public fgr: number = 255;
	@Input() public fgg: number = 255;
	@Input() public fgb: number = 255;

	/**
	* 'plug into' DOM canvas element using @ViewChild
	*/
	@ViewChild('canvas') canvasElement: ElementRef;

	//private drawVisual: number;

	private analyser: AnalyserNode;

	private frequencyDataBuffer: Uint8Array;
	private frequencyDataBufferLength: number;

	/**
	* Reference Canvas object
	*/
	private nativeCanvasElement: any;

	/**
	* Reference the context for the Canvas element
	*/
	private canvasContext2d: any;



	constructor() { }




	/**
	Inizializzazione riquadro video
	*/
	private init() {
		let canvas = this.nativeCanvasElement = this.canvasElement.nativeElement;
		if (this.nativeCanvasElement && this.nativeCanvasElement.getContext) {
			this.canvasContext2d = this.nativeCanvasElement.getContext('2d');
			this.canvasContext2d.fillStyle = this.bgColor;
			this.canvasContext2d.fillRect(0, 0, this.nativeCanvasElement.width, this.nativeCanvasElement.height);
		}

		let audioCtx = DeviceProvider.audioContext;// new (AudioContext /*|| webkitAudioContext*/)();

		let analyser = this.analyser = audioCtx.createAnalyser();
		analyser.minDecibels = -90;
		analyser.maxDecibels = -10;
		analyser.smoothingTimeConstant = 0.85;

		let source = audioCtx.createMediaStreamSource(this._stream);
		source.connect(analyser);

		let w = canvas.width;
		let h = canvas.height;

		analyser.fftSize = 256;
		this.frequencyDataBufferLength = analyser.frequencyBinCount;
		this.frequencyDataBuffer = new Uint8Array(this.frequencyDataBufferLength);

		this.canvasContext2d.clearRect(0, 0, w, h);

		//let self = this;

		this.paint();
	}

	private paint() {
		let self = this;
		/*self.drawVisual = */
		if (this._stream) {//Se non è stato rimosso lo stream prosegue
			requestAnimationFrame(() => { self.paint() });//registra il prossimo paint
		}

		this.analyser.getByteFrequencyData(this.frequencyDataBuffer);

		let w = this.nativeCanvasElement.width;
		let h = this.nativeCanvasElement.height;
		let bars = this.frequencyDataBufferLength;

		this.canvasContext2d.fillStyle = this.bgColor;
		this.canvasContext2d.fillRect(0, 0, w, h);//pulizia sfondo

		let barWidth = (w / bars) * 2.5;//eliminiamo le frequenze troppo alte allargando le barre a sinistra
		let x = 0;

		for (let i = 0; i < bars && x < w; i++) {//lavoriamo sulla frequenza i-esima
			let frequencyValue = this.frequencyDataBuffer[i];//0..255
			let barHeight = h * (frequencyValue / 255);//proiezione 0..255 sull altezza dispoinibile

			this.canvasContext2d.fillStyle = 'rgb(' + (frequencyValue * this.fgr / 255) + ',' + (frequencyValue * this.fgg / 255) + ',' + (frequencyValue * this.fgb / 255) + ')';
			this.canvasContext2d.fillRect(x, h - barHeight, barWidth, barHeight);

			x += barWidth + 1;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/frequency-bar-graph/frequency-bar-graph.ts